/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";import TableComponent from "../../components/TableComponent";
import { GridColDef } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";




type OfferTableProps = {
  actionType?: "active" | "scheduled" | "expired";
};


const BookingRsvpTable = ({ actionType = "active" }: OfferTableProps) => {
  const navigate = useNavigate();

  const label = { inputProps: { "aria-label": "Switch demo" } };

  const rows = [
    {
      id: 1,
   
      Date: "26-Jun-2025",
      Time: "6:00 PM",
      EmployeeName: "John Smith",
      Remarks: "I want to invite my parents to the event",



    },
    {
      id: 2,
    
       Date: "26-Jun-2025",
      Time: "6:00 PM",
      EmployeeName: "John Smith",
      Remarks: "I want to invite my parents to the event",
    },
    {
      id: 3,
   
      Date: "26-Jun-2025",
      Time: "6:00 PM",
      EmployeeName: "John Smith",
      Remarks: "I want to invite my parents to the event",
    },
    {
      id: 4,
    
      Date: "26-Jun-2025",
      Time: "6:00 PM",
      EmployeeName: "John Smith",
      Remarks: "I want to invite my parents to the event",
    },
    {
      id: 5,
   
      Date: "26-Jun-2025",
      Time: "6:00 PM",
      EmployeeName: "John Smith",
      Remarks: "I want to invite my parents to the event",
    },
  ];
  const columns: GridColDef<(typeof rows)[number]>[] = [

    { field: "Date", headerName: "Date", flex: 1, minWidth: 100 },
    { field: "Time", headerName: "Time", flex: 1, minWidth: 70,  },
    { field: "EmployeeName", headerName: "Employee Name", flex: 1, minWidth: 160,  },
    { field: "Remarks", headerName: "Note", flex: 1, minWidth: 130,  },
   


 

  ];
  let hidden = ["fullName"];

  return (
    <>
      <div className="sorting_table cards table_cards">
        <TableComponent
          columns={columns?.filter((item) => !hidden.includes(item.field))}
          rows={rows}
        />
      </div>
    </>
  );
};

export default BookingRsvpTable;
